import React, { ReactElement, ReactNode } from 'react';

import Tooltip from '@mui/material/Tooltip';
import { createTheme, ThemeProvider } from '@mui/material/styles';

// theme
import aampeTheme from '../../../constants/aampeTheme';

export type TooltipPlacement =
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';

// Adding only basic props that are most commonly used
// We can anytime change the props to extend the TooltipProps that won't require any change at other places

interface AampeTooltipProps {
    title?: string | ReactNode;
    arrow?: boolean;
    placement?: TooltipPlacement;
    children: ReactElement;
    customZIndex?: number;
    backgroundColor?: string;
    color?: string;
    arrowColor?: string;
    maxWidth?: number;
    padding?: number;
}

const AampeTooltip: React.FC<React.PropsWithChildren<AampeTooltipProps>> = (
    props,
) => {
    const {
        title,
        arrow,
        placement,
        children,
        customZIndex = 10001,
        backgroundColor = aampeTheme.colors.gray700,
        color = aampeTheme.colors.white,
        arrowColor = aampeTheme.colors.gray700,
        maxWidth = 300,
        padding = 4,
    } = props;

    const theme = createTheme({
        components: {
            MuiTooltip: {
                styleOverrides: {
                    tooltip: {
                        fontSize: 14,
                        color: color,
                        backgroundColor: backgroundColor,
                        maxWidth: maxWidth,
                        padding: padding,
                    },
                    arrow: {
                        color: arrowColor,
                    },
                },
            },
        },
        typography: {
            fontFamily: 'Inclusive Sans Variable, Arial, sans-serif',
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <Tooltip
                PopperProps={{ style: { zIndex: customZIndex } }}
                title={title || ''}
                arrow={arrow}
                placement={placement}
                disableHoverListener={!title}
            >
                {children}
            </Tooltip>
        </ThemeProvider>
    );
};

export default AampeTooltip;
